import { Search, X } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ToolCard } from '../components/ToolCard';
import { ToolIcon } from '../components/ToolIcon';
import { toolCategories, tools, toolsInCategory } from '../domain/tools/registry';
import { localize } from '../domain/tools/types';
import { useLanguage } from '../features/language/useLanguage';
import { useFavorites } from '../features/preferences/preferences';
import { searchTools } from '../lib/search';

export function ToolsIndexPage() {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const { favorites, toggleFavorite } = useFavorites();
  const [query, setQuery] = useState('');
  const matches = useMemo(() => searchTools(tools, query, language), [query, language]);
  const isSearching = query.trim().length > 0;

  return (
    <>
      <section className="content-wrap page-hero">
        <div className="page-heading">
          <div><h1>{t('toolLibrary.title')}</h1><p>{t('toolLibrary.description')}</p></div>
        </div>
        <div className="search-shell" style={{ marginBlockStart: '1.6rem' }}>
          <Search size={21} aria-hidden="true" />
          <label className="sr-only" htmlFor="library-search">{t('home.searchLabel')}</label>
          <input id="library-search" className="search-input" type="search" value={query} placeholder={t('home.searchPlaceholder')} onChange={(event) => setQuery(event.currentTarget.value)} />
          {isSearching && <button className="icon-button search-count" type="button" onClick={() => setQuery('')} aria-label={t('home.clearSearch')}><X size={15} /></button>}
        </div>
      </section>
      <section className="content-wrap section-block" aria-live="polite">
        {isSearching ? (
          matches.length > 0 ? (
            <div className="tool-grid">{matches.map((tool) => <ToolCard key={tool.id} tool={tool} favorite={favorites.has(tool.id)} onToggleFavorite={toggleFavorite} />)}</div>
          ) : (
            <div className="empty-state"><Search size={32} /><h2>{t('home.noSearchResults', { query })}</h2></div>
          )
        ) : (
          <div className="category-stack">
            {toolCategories.map((category) => (
              <section key={category.id} aria-labelledby={`library-category-${category.id}`}>
                <div className="category-label">
                  <span className="tool-icon"><ToolIcon category={category.id} /></span>
                  <div><h2 id={`library-category-${category.id}`}>{localize(category.name, language)}</h2><p>{localize(category.description, language)}</p></div>
                </div>
                <div className="tool-grid">{toolsInCategory(category.id).map((tool) => <ToolCard key={tool.id} tool={tool} favorite={favorites.has(tool.id)} onToggleFavorite={toggleFavorite} />)}</div>
              </section>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
